import OmniApiClient from "./base";

export const shopifyExportApi = {
  getStatus: () => OmniApiClient.get("/plenty/export/to/shopify/status"),

  start: (forceRebuild = false) =>
    OmniApiClient.post(
      `/plenty/export/to/shopify${forceRebuild ? "?force_rebuild=true" : ""}`,
    ),

  stop: () => OmniApiClient.post("/plenty/export/to/shopify/stop"),
};
